import { render, staticRenderFns } from "./LevelSelection.vue?vue&type=template&id=4712283e&scoped=true"
import script from "./LevelSelection.vue?vue&type=script&lang=js"
export * from "./LevelSelection.vue?vue&type=script&lang=js"
import style0 from "./LevelSelection.vue?vue&type=style&index=0&id=4712283e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4712283e",
  null
  
)

export default component.exports